import React from "react";
import { getOrgId, getToken } from './UserFunctions';
import * as ShipConstants from '../Global/Constants';
import {getDateFormat,checkIsSystemUser,getProfileAuthorities,getUserInfo,windowsMenusList} from '../Utils/UserFunctions';
import { callGET } from '../Utils/ApiUtil';
import moment from 'moment';
import $ from 'jquery';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { validate as uuidValidate } from 'uuid';
import CryptoJS from 'crypto-js';
import pako from 'pako';
import { IsEncrypted } from "../envConfig";


export const isDevelopmentOrTest = () => {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')
    return true;
  return false;
};

export const parameterizedURLAccessToken = (url) => {
	const accessToken = getToken();
	let tokenParameter = "";
	var pattern = new RegExp(/\?.+=.*/g);
	let paramsOperator = "?";
    if(pattern.test(url)) {
    	paramsOperator = "&";
      
    }
	if(accessToken) {
		tokenParameter = paramsOperator+'access_token='+getToken();
	}

	return ShipConstants.API_URL+url+tokenParameter;
}

export const IsJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
export const stringHasText=(text)=>{
  let returnData= false;
   if(text !== ''&& text !== undefined){
     returnData = true;
   }
   return returnData;
 }
//FIELDS SELECTED VALUE DISPLAY BASED ON FIELDS
export const getSelectedValueBasedOnField = (item,defval='-',valueOnly=false,isNeedPicklistObj=false)=>{
    let selectedValue;
    item.selectedValue = (isSet(item.selectedValue,null)===null)?'':item.selectedValue; 
    if(item.element==='Lookup'|| item.element_original==='Lookup'){
      try {
        if(!IsJsonString(item.displayValue)){
          selectedValue  = isSet(item.displayValue,'');
        }
        let displayName=[];
        let displayNameAll=[];
        if(isSet(item.displayValue,null)!==null && IsJsonString(item.displayValue) === true){
          const selectedValueJSON = JSON.parse(item.displayValue);
            displayName.push(selectedValueJSON.dpnm);
            selectedValue = displayName.join(' ');
          }else if(IsJsonString(stringHasText(item.element_original)?item.selectedValueText : item.selectedValue) === true) {
            const selectedValueJSON = JSON.parse(stringHasText(item.element_original)?item.selectedValueText : item.selectedValue);
          if(selectedValueJSON && selectedValueJSON.dpnm){
            displayName.push(selectedValueJSON.dpnm);
          }
          if(selectedValueJSON && selectedValueJSON.fieldGroups) {
          selectedValueJSON.fieldGroups.forEach((item)=>{
            item.data.forEach((itemData)=>{
              const selectedItemValue = getSelectedValueBasedOnField(itemData);
                if(itemData.element!=='ImageUpload' && selectedItemValue!=='' && selectedItemValue!==undefined && selectedItemValue!==null && selectedItemValue!=='-'){
                  if(itemData.is_default_displayname===true && displayName.length<2){
                    displayName.push(selectedItemValue);
                  }
                  if(displayNameAll.length<2){
                    displayNameAll.push(selectedItemValue);
                  }
                }
            });
          })
          }
          
          const endPos = (displayNameAll.length<=2)? displayNameAll.length:2;
          displayName = (displayName.length===0)?displayNameAll.slice(0,endPos):displayName;
          selectedValue = displayName.join(' ');
        }
      } catch (e) {
        console.log(e)
        selectedValue = '';//isSet(item.displayValue,'');
      }
    }else if(item.element==='MultiLookup'|| item.element_original === 'MultiLookup'){
      try {
        const selectedValueJSON = JSON.parse(stringHasText(item.element_original)? item.selectedValueText : item.selectedValue);
        let displayName=[];
        selectedValueJSON.forEach((section)=>{
          let displayNameData = [];
          let displayNameDataAll = [];
          section.fieldGroups.forEach((item)=>{
            item.data.forEach((itemData)=>{
              const selectedItemValue = getSelectedValueBasedOnField(itemData);
              if(selectedItemValue!=='' && selectedItemValue!==undefined && selectedItemValue!==null && selectedItemValue!=='-'){
                if(itemData.is_default_displayname===true && displayNameData.length<2){
                  displayNameData.push(selectedItemValue);
                }
                if(displayNameDataAll.length<2){
                  displayNameDataAll.push(selectedItemValue);
                }
              }
            })
          })
          const endPos = (displayNameDataAll.length<=2)? displayNameDataAll.length:2;
          // console.log(displayNameDataAll,displayNameData);
          displayNameData = (displayNameData.length===0)?displayNameDataAll.slice(0,endPos):displayNameData;
          displayName.push(displayNameData.join(' '));
        })
        if(item.element_original !== undefined){
          selectedValue = <span className="tbodyTitle" title={displayName.join(', ')}> { displayName.join(', ') }</span>
        }else{
          selectedValue = displayName.join(', ');
        }

      } catch (e) {
        selectedValue = "";
        // console.log('field lookup...');
      }
    }else if(item.element==='MultiSelect'|| item.element_original === "MultiSelect"){
      let selectedOption = [];
      if(item.selectedValue!==null){  
        item.options.forEach((option)=>{
          if(item.selectedValue.split(',').indexOf(option.value)!== -1 || item.selectedValue.split(',').indexOf(option.id)!== -1){ 
            selectedOption.push(option.value);
          }
        })
      }
      selectedValue = selectedOption.join(',');
    }else if(item.element==='User' || item.element_original === "User"){
      try {
      const selectedValueJSON = JSON.parse(item.selectedValue);
      // console.log(selectedValueJSON);
        let displayName=[];
        selectedValueJSON.forEach((data)=>{
          displayName.push(data.first_name+' '+data.last_name);
      })
      selectedValue = displayName.join(',');
    } catch (e) {
      selectedValue = "";
    }
    }else if(item.element==='PickList' || item.element_original ==='PickList'){
      // console.log(item.options);
      
      getPicklistOptions(item).forEach((option)=>{
        if(option.id===item.selectedValue){
          selectedValue = (isNeedPicklistObj===true)?option:option.value;
        }
      })
    }else if(item.element==='Date'){
      if(item.selectedValue!==undefined && item.selectedValue!==null && item.selectedValue!==''){
        selectedValue = (moment(item.selectedValue, getDateFormat(), true).isValid()===true)?item.selectedValue:moment(item.selectedValue, 'YYYY-MM-DD HH:mm:ss.S', true).format(getDateFormat());
        // console.log('selectedValue',selectedValue,item.selectedValue);
      }
    }else if(item.element==='DateTime'){
      if(item.selectedValue!==undefined && item.selectedValue!==null && item.selectedValue!==''){
        selectedValue = (moment(item.selectedValue, getDateFormat('DateTime'), true).isValid()===true)?item.selectedValue:moment(item.selectedValue, 'YYYY-MM-DD HH:mm:ss.S', true).format(getDateFormat('DateTime'));
      }
    }else if(item.element==='FileUpload'){
      selectedValue = '';
       if(item.files!==undefined){item.files.forEach((file,index)=>{
          selectedValue+= file.label; 
        })
      }
      return selectedValue;
    }else if(item.element==='ImageUpload'){
      selectedValue = [];
      if(item.files!==undefined){
      item.files.forEach((file)=>{
        // console.log(file);
        selectedValue.push(file.id); 
      })
    }
      return selectedValue;
    }else if(item.element==='CheckBoxes'){
      selectedValue = <span></span>;
      if(isSet(item.selectedValue,'false').toString()==='true'){
        selectedValue = 
          <span title="Selected">
            <i className="fas fa-check	text-success fa-lg"></i>
          </span>
      }else if(isSet(item.selectedValue,'false').toString()==='false'){
        selectedValue = 
        <span title="Not Selected">
          <i className="fas fa-times	text-danger fa-lg"></i>
        </span>
      }
      if(valueOnly===true){
        // console.log('item',item);
        const truthyValues = [true, "true", 1, "1","TRUE"];
        selectedValue = truthyValues.includes(item.selectedValue) ? '1' : '0';
        // selectedValue = (Boolean(JSON.parse(String(item.selectedValue).toLowerCase())) === true) ? '1' : '0';
        // selectedValue  = (Boolean(isSet(item.selectedValue,false))===true)?'1':'0';
      }
    }
    /*else if(item.element==='Barcode'){
      selectedValue = item.selectedValue;
      const imgUrl = (selectedValue!=='' && selectedValue!==undefined && selectedValue!==null)?parameterizedURLAccessToken('files/download?fileId='+selectedValue):'';
      // return '-';
      return imgUrl;
    }*/
    else if( equalIgnoreCase(item.element_original,'TextInput') || equalIgnoreCase(item.element_original,'TextArea') ){
      selectedValue = <span className="tbodyTitle" title={item.selectedValue}> {item.selectedValue }</span>
    }
    else{
      //console.log('item.element','item'.element);
      selectedValue = item.selectedValue;
    }
    selectedValue =  (selectedValue===null || selectedValue==='' || selectedValue===undefined)?defval:selectedValue;
    return (selectedValue===defval && (item.element==='Date' || item.element==='DateTime'))?'':selectedValue;
  }

export const getPicklistOptions = (item)=>{
   let selectOptions = [];
  try{
    if(item.picklist_type==='CURRENCY'){
      const currencyList =  currencyListUtil();
      currencyList.forEach((currency)=>{
        selectOptions.push({
            value:currency.value,
            id:currency.key
        });
    });
    }else if(item.picklist_type==='COUNTRY'){
      const countryList =  (userUtilList().country_list!==undefined && userUtilList().country_list!==null)?userUtilList().country_list:{};
      Object.keys(countryList).forEach(function(key) {
        selectOptions.push({
          id: key,
          value: countryList[key],
        })
      })
    }else{
      selectOptions = item.options;
    }
  }catch(e){

  }
  return selectOptions;
 } 
  
export const cDateTime = (value)=>{
  let convertedValue = '';
  if(value!=='' && value!==null && value!==undefined){
    convertedValue = moment(value, 'YYYY-MM-DDTHH:mm:ss', true).format(getDateFormat('DateTime'));
  }
  return convertedValue;
}  
export const convertContitionsJSONvalues= (condJSON)=>{
  // const values = condJSON.values;
  const {field,values} = condJSON;
  let valuesInArr = [];
  if(Array.isArray(values)===false){
    valuesInArr = values;
  }else{
    values.forEach((item)=>{
      if(field.element==='PickList' || field.element==='MultiSelect' || field.element==='User'){
        valuesInArr.push(cValue(item.value));
      }else if(field.element==='Lookup'){
        valuesInArr.push(cValue(item.value));
      }else if(isSet(item.label,null)!==null){
          valuesInArr.push(cValue(item.label));
      }
     
      return item;
    })
  }
  // console.log("valuesInArr",valuesInArr);
  return valuesInArr;
}  
 export const checkIsStatusFieldIsExists = (fieldGroups,details=false)=>{
  let statusFieldExist = false;
  let fieldDetails = null;
  let updateJSON = {};
  fieldGroups.forEach((section)=>{
    // if(isSet(section.system_field_group,false)===false){
      if(section.type!=='subform'){
      section.data.forEach((field)=>{
        if(field.element==='PickList'){
          if(field.is_status_picklist!==undefined && (field.is_status_picklist===true || field.is_status_picklist==='true')){
            statusFieldExist = true;
            fieldDetails = field;
            updateJSON = {
              section_index: section.section_index,
              itemIndex:field.itemIndex,
              item:field
            }
          }
        }
      })
    }
    // }
  })
  if(details===false){
    return statusFieldExist;
  }else{
    return {
      statusFieldExist:statusFieldExist,
      field:fieldDetails,
      updateJSON:updateJSON
      }
  }
 }

 export const checkIsAvatarIsExists = (fieldGroups,details=false)=>{
  let avatarFieldExist = false;
  let fieldDetails = null;
  let avatar = '/assets/img/profile2.jpg';
  let updateJSON = {};
  fieldGroups.forEach((section)=>{
    section.data.forEach((field)=>{
      if(field.element==='ImageUpload'){
        if(field.is_avatar!==undefined && (field.is_avatar===true || field.is_avatar==='true')){
          avatarFieldExist = true;
          fieldDetails = field;
          avatar = (field.files.length>0)?parameterizedURLAccessToken('files/download?fileId='+field.files[0].id):'/assets/img/profile2.jpg'
            
          updateJSON = {
            section_index: section.section_index,
            itemIndex:field.itemIndex,
            item:field,
            // files:(item.files.length>0)?item.files[0]:''
          }
        }
      }
    })
  })
  if(details===false){
    return avatarFieldExist;
  }else{
    return {
      avatarFieldExist:avatarFieldExist,
      avatar:avatar,
      field:fieldDetails,
      updateJSON:updateJSON
      }
  }
 }
  export const getSelectedValueFromForm = ({fieldGroups,subformData,mappingTags},object,isAllowNextLoop=true)=>{
    const {fieldData,searchBy,rulesMapping,windowName} = object;
    let conditionField = { isExist:false };
    // if(object.fieldName==='Loggedin User Role'){
    //   try{
    //     const userInfo = getUserInfo();
    //     const userInfoData = userInfo.data;
    //     const selectedValue = userInfoData.role_name;
    //     // console.log(" ",userInfoData);
    //     // formulaValue = {
    //     //   selectedValue:selectedValue
    //     // }
    //   }catch(e){
    //     console.log('e',e);
    //   }
    // }else 
    if(isSet(object.fieldName,'').toLowerCase()==='loggedin user profile'){
        const userInfo = getUserInfo();
        try{
          const userInfoData = userInfo.data;
          // const selectedValue = userInfoData.profile_name;
          const selectedValue  = userInfoData.profile_id;
          conditionField = {
            field:{element:'User',selectedValue:selectedValue},
            selectedValue:selectedValue,
            sectionIndex:0,
            fieldIndex:0,
            isExist:true
          }
        }catch(e){
  
        }
    }

    if(isSet(object.fieldName,'').toLowerCase()==='tag'){
      let mappingValueArr = [];
      mappingTags.forEach((tag)=>{
        mappingValueArr.push(tag.tag_id);
      });
      conditionField = {
        field:{element:fieldData.field_type_name},
        sectionIndex:0,
        fieldIndex:0,
        selectedValue:mappingValueArr,
        isExist:true
      }
    }
      fieldGroups.forEach( (section,sectionIndex)=>{
        if(conditionField.isExist===true){ return false; }
        if(searchBy==='sectionId' && section.id===object.id){
          conditionField = {
            section:section,
            sectionIndex:sectionIndex,
             isExist:true
          }
        }
        if(searchBy==='name' && isSet(fieldData.absolute_window,null)!==null){
          if(section.id===isSet(fieldData.absolute_window,null)){
            section.data.forEach(async (field,fieldIndex)=>{
              if(object.fieldName.toLowerCase()===field.api_custom_field_name.toLowerCase() || field.label.blocks[0].text.toLowerCase()===object.fieldName.toLowerCase()){
                let selectedArr = [];
                subformData.forEach((subSec)=>{
                  if(subSec.field_group_section_id===section.id){
                    subSec.subform_rows.forEach((subRows)=>{
                      subRows.subform_column_values.forEach((subCol)=>{
                        if(subCol.table_descriptor_id===field.id){
                          selectedArr.push(cValue(subCol.selected_value));
                        }
                      })
                    })
                  }
                });
                conditionField = {
                  field:field,
                  sectionIndex:sectionIndex,
                  fieldIndex:fieldIndex,
                  isSubForm:true,
                  selectedValue:selectedArr,
                  isExist:true
                }
              }
            })
          }
        }
        section.data.forEach(async (field,fieldIndex)=>{
          if(conditionField.isExist===true){ return false; }
          let selectedValue = isSet(field.selectedValue,'');
          if(field.element==='ImageUpload' || field.element==='FileUpload'){
            let filesArr = [];
            isSet(field.files,[]).forEach((file)=>{
              filesArr.push(file.label.replace(/\.[^/.]+$/, ""));
            })
            selectedValue = filesArr;
          }else if(field.element==='Reminder'){
            const {remind_date,remind_time } = isSet(field.reminder,{remind_date:'',remind_time:''});
             selectedValue = moment(isSet(remind_date,'')+' '+isSet(remind_time,''), 'YYYY-MM-DD HH:mm', true).format(getDateFormat(field.element));
            //  console.log('selectedValue',selectedValue);
          }else if(field.element==='Formula' && isAllowNextLoop===true){
            const formulaExp = field.formula_expression;
            const paramsPattern = /[^${\}]+(?=})/g;
            let extractParams = formulaExp.match(paramsPattern);
            let formulaExpExe = formulaExp;
            isSet(extractParams,[]).forEach((expFiedName)=>{
              const exactFieldName = expFiedName.replace(windowName+'.','');
              const formulaValue = getSelectedValueFromForm({fieldGroups,subformData,mappingTags},{searchBy:'name',fieldData:{},fieldName:exactFieldName},false);
              formulaExpExe = formulaExpExe.replace('${'+expFiedName+'}',formulaValue.selectedValue);
              
            })
            try{
              selectedValue = eval(formulaExpExe)
            }catch(e){
            }
            // console.log('conditionField',selectedValue);
          }else if(field.element==='AutoNumber'){
            selectedValue = (selectedValue==='')?isSet(field.nextNumber,''):selectedValue;
          }
          if(searchBy==='name' && isSet(fieldData.absolute_window,null)!==null){
            const absoluteDetails = isSet(fieldData.absolute_window,'').toString().split('.');
            // console.log('absoluteDetails',absoluteDetails,field.id);
            // console.log('absolute...',fieldData.absolute_window,absoluteDetails);
            if(absoluteDetails[0]===field.id){
              let selectedValue = [];
              if(absoluteDetails.length===1){
                absoluteDetails.push(isSet(fieldData.table_descriptor_id,null));
              }
              let rulesMappingArr = [];
              let validCnt = 0;
              // console.log('field.ruleMapping',absoluteDetails);
              isSet(field.ruleMapping,[]).forEach((i)=>{
                try{
                  if(Object.entries(i).length>0){
                    validCnt++;
                  }
                }catch(e){

                }
                
              })
              if(validCnt===0){
                rulesMappingArr = [...isSet(field.ruleMapping,[]),rulesMapping];
              }else{
                rulesMappingArr = [...isSet(field.ruleMapping,[])];
              }
              if(isSet(selectedValue,null)===null){
                rulesMappingArr = [];
              }
              // console.log('field.ruleMapping',rule);
              // console.log('rulesMappingArr',rulesMappingArr,);
                absoluteDetails.forEach((absId)=>{
                  try{
                    // console.log('rulesMappingArr',rulesMappingArr,absId);
                    rulesMappingArr.forEach((rule)=>{
                      Object.entries(rule).forEach(([key, val]) => {
                        const searchIndexing = key.toString().split('.').findIndex(i=>i===absId);
                        if(searchIndexing!==-1){
                          // console.log('valuee...',val);
                          if(Array.isArray(isSet(isSet(val,null),''))===true){
                            selectedValue = [
                              ...selectedValue,
                              ...isSet(isSet(val,null),'')
                            ]
                            // console.log('key',key.toString().split('.'),val);
                        
                          // if(Array.isArray(isSet(isSet(rule,null)[key],''))===true){
                          //   selectedValue = [
                          //     ...selectedValue,
                          //     ...isSet(isSet(rule,null)[key],'')
                          //   ]
                          }else{
                            // console.log('sss',isSet(rule,null)[key],'');
                            selectedValue.push(isSet(isSet(rule,null)[key],''));
                          }
                        }
                      })
                      
                      
                    })
                    // console.log('selectedValue',selectedValue);
                    // console.log('isSet(field.ruleMapping[descriptorId])',absId,isSet(field.ruleMapping,null)[absId]);
                  }catch(e){
                    selectedValue.push(cValue(selectedValue));
                  }
                  
                })
              // console.log('selectedValue',selectedValue);
              conditionField = {
                field:field,
                selectedValue:selectedValue,//.join(','),
                sectionIndex:sectionIndex,
                fieldIndex:fieldIndex,
                isExist:true
              }
            //  console.log('conditionField_11111',conditionField);
            }
          }else  if(isSet(field.label,null)!==null && searchBy==='name' && (field.label.blocks[0].text.toLowerCase()===object.fieldName.toLowerCase() || field.api_custom_field_name.toLowerCase()===object.fieldName.toLowerCase())){
            conditionField = {
              field:field,
              sectionIndex:sectionIndex,
              fieldIndex:fieldIndex,
              selectedValue:cValue(selectedValue),
              isExist:true
            }
          }else if(searchBy==='id' && field.id===object.id){
            conditionField = {
              field:field,
              selectedValue:cValue(selectedValue),
              sectionIndex:sectionIndex,
              fieldIndex:fieldIndex,
              isExist:true
            }
          }
          // console.log('searchby..',searchBy,field.id,object.id);
        })
      })
      return conditionField;
  }
  export const checkIsBolleanValue = (val)=>{
    if(val==='TRUE' || val==='true' || val===true){
      return true;
    }else{
      return false;
    }
  }
  export const  rulesChecking =(obj)=>{
    // console.log('obj',obj);
    switch (obj.filter.type) {
      case 'comparison':
        if(Array.isArray(obj.value)===true){
          obj.value = obj.value[0];
        }
        const operator  = obj.filter.operator;
        // console.log('obj.selectedValue',obj.selectedValue,obj.value,operator);
        try{
          // console.log("rulesChecking",obj.selectedValue, operator,obj.value);
          return eval("obj.selectedValue" + operator + "obj.value");
        }catch(e){
          // console.log('e',e,operator);
          return false;
        }
      case 'functional':
        try{
          // console.log('rulesChecking...',obj.filter.method,obj.selectedValue,obj.value,obj.field);
          return eval(obj.filter.method+"(obj.selectedValue,obj.value,obj.field)")
        }catch(e){
          return false;
        }
      default:
        return false;
      }
  }

  export const isValueEmpty = (selectedValue,value,field)=>{
    if(Array.isArray(selectedValue)===true && selectedValue.length===0){
      return true;
    }else if(isSet(selectedValue,null,field.element)===null && !Array.isArray(selectedValue)){
      return true;
    }else{
      return false;
    }
  }

  export const isNotEmpty = (selectedValue,value,field)=>{
    if(Array.isArray(selectedValue)===true && selectedValue.length>0){
      return true;
    }else if(isSet(selectedValue,null,field.element)!==null && !Array.isArray(selectedValue)){
      return true;
    }else{
      return false;
    }
  }
  export const isValueNotIn =(selectedValue,value,field)=>{
    let isExists = 0;
    if(field.element==='Date' || field.element==='DateTime' || field.element==='Reminder'){
      return isDaysAgo(selectedValue,value,field,'!=');
    }else{
      const selectedValueInArr = (Array.isArray(selectedValue)===true)?selectedValue:isSet(selectedValue,'').split(',');
      if(selectedValueInArr.length>0){
        selectedValueInArr.forEach((item)=>{
          if(value.indexOf(item) !== -1){
              isExists++;
            }
        })
      }
      if(isExists===0){
        return true;
      }else{
        return false;
      }
    }
  }

  export const isValueIn =(selectedValue,value,field)=>{
    let isExists = 0;
    if(field.element==='Date' || field.element==='DateTime' || field.element==='Reminder'){
      return isDaysAgo(selectedValue,value,field,'==');
    }else{
      const selectedValueInArr = (Array.isArray(selectedValue)===true)?selectedValue:isSet(selectedValue,'').split(',');
    //  const selectedValueInArr = (selectedValue===undefined || selectedValue===null)?[]:selectedValue.split(',');
    // console.log('selectedValueInArr',selectedValueInArr,value);
      if(selectedValueInArr.length>0){
        selectedValueInArr.forEach((item)=>{
          if(value.indexOf(item) !== -1){
              isExists++;
            }
        })
      }
      if(isExists>0){
        return true;
      }else{
        return false;
      }
   }
 }
 export const isNotEqualTo = (selectedValue,value)=>{
  let returnData = false;
  if(Array.isArray(value)===true){
      value.forEach((itm)=>{
        if(Array.isArray(selectedValue)===true){
          if(isSet(selectedValue,'').indexOf(itm)===-1){
            returnData = true;
          }
        }else if(isSet(selectedValue,'')!==itm){
          returnData = true;
        }
      });
  }else if(isSet(selectedValue,'')!==value){
    returnData =  true;
  }
  return returnData;
 }

 export const isEqualTo = (selectedValue,value)=>{
  let returnData = false;
  if(Array.isArray(value)===true){
      value.forEach((itm)=>{
        if(Array.isArray(selectedValue)===true){
          if(isSet(selectedValue,'').indexOf(itm)!==-1){
            returnData = true;
          }
        }else if(isSet(selectedValue,'')===itm){
          returnData = true;
        }
      });
  }else if(isSet(selectedValue,'')===value){
    returnData =  true;
  }
  return returnData;
}

export const isNumber = (n)=> { return !isNaN(parseFloat(n)) && !isNaN(n - 0) } 

export const cValue = (val)=>{
  return (isNumber(val)===true)?parseFloat(val):val;
}
export const isInBetween = (selectedValue,value,field)=>{
  let returnData = false;
  if(Array.isArray(value)===true){
    if(field.element==='Date' || field.element==='DateTime' || field.element==='Reminder'){
      if(isSet(value,null)!==null && isSet(value,[]).length>1){
        let convertedSelectedValue = moment(selectedValue, getDateFormat(field.element), true);
        let fromDate = moment(value[0],getDateFormat(field.element), true);
        let toDate = moment(value[1],getDateFormat(field.element), true);
        if(convertedSelectedValue >= fromDate  && convertedSelectedValue <= toDate){
          returnData =  true; 
        }
      }
    }else{
      let updatedSelectedValue = isSet(selectedValue,'');
      if(isSet(value,null)!==null && isSet(value,[]).length>1){
        if(updatedSelectedValue >= isSet(value,[])[0]  && updatedSelectedValue <= isSet(value,[])[1]){
          returnData =  true; 
        }
      }
    }
    
  }
  return returnData;
}

export const isNotInBetween = (selectedValue,value,field)=>{
  let returnData = true;
  if(Array.isArray(value)===true){
    if(field.element==='Date' || field.element==='DateTime' || field.element==='Reminder'){
      if(isSet(value,null)!==null && isSet(value,[]).length>1){
        let convertedSelectedValue = moment(selectedValue, getDateFormat(field.element), true);
        let fromDate = moment(value[0],getDateFormat(field.element), true);
        let toDate = moment(value[1],getDateFormat(field.element), true);
        if(convertedSelectedValue >= fromDate  && convertedSelectedValue <= toDate){
          returnData =  false; 
        }
      }
    }else{
      const updatedSelectedValue = isSet(selectedValue,'');
      if(isSet(value,null)!==null && isSet(value,[]).length>1){
        if(updatedSelectedValue >= isSet(value,[])[0]  && updatedSelectedValue <= isSet(value,[])[1]){
          returnData =  false;
        }
      }
    }
   
  }
  return returnData;
}
 

 
  export const isContains = (selectedValue,value)=>{
    let returnData = false;
    if(Array.isArray(value)===true){
      value.forEach((itm)=>{
        if(isSet(selectedValue,null)!==null && isSet(selectedValue,[]).toString().indexOf(itm) !== -1){
          returnData = true;
        }
      });
    }else if(isSet(selectedValue,null)!==null && isSet(selectedValue,[]).toString().indexOf(value) !== -1){
      returnData =  true;
    }
    return returnData;
  }

  export const isSelected = (selectedValue)=>{
    if(checkIsBolleanValue(selectedValue)===true){
      return true;
    }
    return false;
  }
  export const isNotSelected = (selectedValue)=>{
    if(checkIsBolleanValue(selectedValue)===false){
      return true;
    }
    return false;
  }
  export const isChanged = (selectedValue,value)=>{
    if(selectedValue !==""){
      return true;
    }
    return false;
  }

  export const isStartsWith = (selectedValue,value)=>{
    // console.log('selectedValue,value',selectedValue,value,isSet(selectedValue,'').toString())
    let returnData = false;
    if(Array.isArray(value)===true){
        value.forEach((itm)=>{
          if(selectedValue!=='' && selectedValue!==null && isSet(selectedValue,'').toString().startsWith(itm) === true){
            returnData = true;
          }
        });
    }else if(selectedValue!=='' && selectedValue!==null && selectedValue.startsWith(value) ===true){
      returnData =  true;
    }
    // console.log('returnData',returnData);
    return returnData;
  }

  export const isEndsWith = (selectedValue,value)=>{
    let returnData = false;
    if(Array.isArray(value)===true){
        value.forEach((itm)=>{
          if(selectedValue!=='' && selectedValue!==null && isSet(selectedValue,'').toString().endsWith(itm) === true){
            returnData = true;
          }
        });
    }else if(selectedValue!=='' && selectedValue!==null && selectedValue.endsWith(value) === true){
      returnData =  true;
    }
    return returnData;
  }
  export const isNotContains = (selectedValue,value)=>{
    let returnData = false;
    if(Array.isArray(value)===true){
      value.forEach((itm)=>{
        if(isSet(selectedValue,null)!==null && isSet(selectedValue,[]).toString().indexOf(itm) === -1){
          returnData = true;
        }
      });
    }else if(isSet(selectedValue,null)!==null && isSet(selectedValue,[]).toString().indexOf(value) === -1){
      returnData =  true;
    }
    return returnData;
  }

  export const isBeforeDate = (selectedValue,value,field)=>{
    let convertedSelectedValue = moment(selectedValue, getDateFormat(field.element), true).format('YYYY-MM-DD HH:mm:ss');
    if(Array.isArray(value)===true){
      value = value[0];
    }
    let beforeDate = moment(value, getDateFormat(field.element), true).format('YYYY-MM-DD HH:mm:ss');
    if(convertedSelectedValue!=='Invalid date' && beforeDate!=='Invalid date' && convertedSelectedValue <= beforeDate){
      return true;
    }
    return false;
  }

  export const isAfterDate = (selectedValue,value,field)=>{
    let convertedSelectedValue = moment(selectedValue, getDateFormat(field.element), true).format('YYYY-MM-DD HH:mm:ss');
    if(Array.isArray(value)===true){
      value = value[0];
    }
    let afterDate = moment(value, getDateFormat(field.element), true).format('YYYY-MM-DD HH:mm:ss');
    if(convertedSelectedValue!=='Invalid date' && afterDate!=='Invalid date' && convertedSelectedValue > afterDate){
      return true;
    }
    return false;
  }

  export const isYesterday = (selectedValue,value,field)=>{
    let convertedSelectedValue = moment(selectedValue, getDateFormat(field.element), true).format('YYYY-MM-DD');
    let yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
    if(convertedSelectedValue === yesterday){
      return true;
    }
    return false;
  }

  export const isTodayDate = (selectedValue,value,field)=>{
    let convertedSelectedValue = moment(selectedValue, getDateFormat(field.element), true).format('YYYY-MM-DD');
    let todayDate = moment().format('YYYY-MM-DD');
    if(convertedSelectedValue === todayDate){
      return true;
    }
    return false;
  }

  export const isConditionOn = (selectedValue,value,field)=>{
    if(Array.isArray(value)===true){
      value = value[0];
    }
    if(field.element==='Date' || field.element==='DateTime' || field.element==='Reminder'){
      let convertedSelectedValue = moment(selectedValue, getDateFormat(field.element), true);
      let todayDate = moment(value,getDateFormat(field.element), true);
      if(convertedSelectedValue.isSame(todayDate)){
        return true;
      }
    }else if(selectedValue===value){
      return true;
    }
    
    return false;
  } 
  export const isGreaterThan = (selectedValue,value,field)=>{
    if(Array.isArray(value)===true){
      value = value[0];
    }
    if(field.element==='Date' || field.element==='DateTime' || field.element==='Reminder'){
      return isDaysAgo(selectedValue,value,field,'>');
    }else{
      if(isSet(selectedValue,'',field.element)>value){
        return true;
      }else{
        return false;
      }
    }
  }

  export const isLessThan = (selectedValue,value,field)=>{
    if(field.element==='Date' || field.element==='DateTime' || field.element==='Reminder'){
      return isDaysAgo(selectedValue,value,field,'<');
    }else{
      if(isSet(selectedValue,'',field.element)<value){
        return true;
      }else{
        return false;
      }
    }
  }

  export const isExactly = (selectedValue,value,field)=>{
    if(field.element==='Date' || field.element==='DateTime' || field.element==='Reminder'){
      return isDaysAgo(selectedValue,value,field,'===');
    }else{
      if(selectedValue===value){
        return true;
      }else{
        return false;
      }
    }
  }

  const isDaysAgo = (selectedValue,value,field,operator)=>{
    let convertedSelectedValue = moment(selectedValue, getDateFormat(field.element), true).format('YYYY-MM-DD');
    // HH:mm:ss
    let beforeDates = moment().subtract(value, 'days').format('YYYY-MM-DD');
    if(convertedSelectedValue!=='Invalid date' && beforeDates!=='Invalid date'){
      const obj = {selectedValue:convertedSelectedValue,value:beforeDates};
      if(eval("obj.selectedValue" + operator + "obj.value")){
        return true;
      }
    }
   
    return false;
  }
  
  export const fileNameShortenForDisplay =(itemFileLabel)=>{
    const ext = itemFileLabel.split('.').pop();
    let leftRightStrings = itemFileLabel.split('.');
    let fName = leftRightStrings[0];
    let lengthFname = fName.length;
    if(lengthFname > 15){
      itemFileLabel = fName.substr(0,10) + "..." + fName.substr(-5) + "." +ext;
    }
    return itemFileLabel;
  }

  //FIELD FILTER  LIST FOR LAYOUT AND VALIDATION RULES
  export const field_filter = {
    is_starts_with:{type:'functional',method:'isStartsWith'},
    is_selected:{type:'functional',method:'isSelected'},
    is_not_selected:{type:'functional',method:'isNotSelected'},
    is_not_equal_to:{type:'functional',method:'isNotEqualTo'},
    is_not_empty:{type:'functional',method:'isNotEmpty'},
    is_not_contains:{type:'functional',method:'isNotContains'},
    is_less_than_or_equal_to:{type:'comparison',operator:'<='},
    is_less_than:{type:'functional',method:'isLessThan'},
    is_greater_than_or_equal_to:{type:'comparison',operator:'>='},
    is_greater_than:{type:'functional',method:'isGreaterThan'},
    is_exactly:{type:'functional',method:'isExactly'},
    is_equal_to:{type:'functional',method:'isEqualTo'},
    is_ends_with:{type:'functional',method:'isEndsWith'},
    is_empty:{type:'functional',method:'isValueEmpty'},
    is_contains:{type:'functional',method:'isContains'},
    is_changed:{type:'functional',method:'isChanged'},
    is_not_in:{type:'functional',method:'isValueNotIn'},
    is_in:{type:'functional',method:'isValueIn'},
    on:{type:'functional',method:'isConditionOn'},
    is_before:{type:'functional',method:'isBeforeDate'},
    is_after:{type:'functional',method:'isAfterDate'},
    yesterday:{type:'functional',method:'isYesterday'},
    today:{type:'functional',method:'isTodayDate'},
    is_not_in_between:{type:'functional',method:'isNotInBetween'},
    is_in_between:{type:'functional',method:'isInBetween'},
    this_year:{},
    this_week:{},
    this_month:{},
    last_week:{},
    last_month:{},
    is_blocked:{},
    is_not_blocked:{},
    in_the_last:{},
    due_in:{},
  }
// FIELD PERMISSIONS FOR LAYOUT CREATION 
  export const layoutFieldPermission =(item,permission)=>{
    if(checkIsSystemUser()){
      return true;
    }else if(permission==='EDITABLE' && (item.is_editable===true)){   
      return true;
    }else if(permission==='REMOVABLE' && (item.is_removable===true)){
      return true;
    }else{
      return false;
    }
  }
  export const conditionRulesChecking = (conditionField,cond)=>{
    let validationResult = '';
      if(isSet(conditionField.isSubForm,false)===true){
        let subformValidationResult = '';
        conditionField.selectedValue.forEach((subFormVal,subFormIndex)=>{
          if(subFormIndex>0){
            subformValidationResult+=' && ';
          }
          subformValidationResult+=' (true==='+rulesChecking({
            filter:field_filter[(cond.filter).split(' ').join('_')],
            selectedValue:subFormVal,
            field:conditionField.field,
            value:convertContitionsJSONvalues({
              values:cond.values,
              field:conditionField.field,
              field_filter:cond.filter,
            })
          })+' )';
        })
        validationResult = (subformValidationResult!=='')?eval(subformValidationResult):'';
      }else{
        // console.log('conditionField,cond',conditionField,cond);
        validationResult = rulesChecking({
          filter:field_filter[(cond.filter).split(' ').join('_')],
          selectedValue:conditionField.selectedValue,
          field:conditionField.field,
          value:convertContitionsJSONvalues({
            values:cond.values,
            field:conditionField.field,
            field_filter:cond.filter,
          })
        });
      }
    return validationResult;
  }
  export const onLoadRulesCheck = (formData,rules)=>{
    // const {fieldGroups,subformData} = formData;
    // console.log('rules',rules);
    let validationResult ='(true===true)';
    if(rules.length>0){
      validationResult+=' && (';
    }
    // console.log('formData',formData);
    rules.forEach((rule,ruleIndex)=>{
      const conditionField = getSelectedValueFromForm(formData,{
        searchBy:'id',id:rule.table_descriptor_id,
        fieldData:{...rule}
      });
      if(conditionField.isExist===true){
        if(ruleIndex>0){
          if(isSet(rule.logical_operator,'')==='AND'){
            validationResult+=' &&';
          }else if(isSet(rule.logical_operator,'')==='OR'){
            validationResult+=' || ';
          }
        }
        validationResult+=' (true==='+conditionRulesChecking(
          conditionField,
          {values:rule.values,filter:rule.filter_name})+' )';
          
      }else{
        validationResult+='&& (true===false)';
      }
      
    });
    if(rules.length>0){
      validationResult+=')';
    }
    // console.log('onLoadRulesCheck',validationResult);
    try{
      if(eval("("+validationResult+")")){
        return true;
      }
    }catch(e){

    }
    return false;
  }
  
//fieldGroups:updateFieldGroupsState,
// subformData:updateSubformDataState
  export const layoutRulesValidation = (layoutRules,formData,rulesMapping,layoutObject,validationForms)=>{
    // console.log('layoutObject',formData,layoutRules);
    const {fieldGroups,subformData} = formData;
    let updateFieldGroups = fieldGroups;
    let updateSubFormData = subformData;
    const defObj = {
      rulesMapping:rulesMapping,
      windowName:layoutObject.windowName
    }
    // console.log('layoutRules',layoutRules);
    Object.entries(layoutRules).map(([key, field]) => {
      let validationResult = '';
      if(field.is_active===true && field.conditions!==null && field.conditions!==undefined){
        field.conditions.forEach((cond)=>{
          const conditionField = getSelectedValueFromForm(formData,{
            searchBy:'name',fieldName:field.display_name,
            fieldData:field,
            ...defObj
          });
        
          if(conditionField.isExist===true){
            validationResult = conditionRulesChecking(conditionField,{values:cond.values,filter:cond.field_filter});
          }
          // console.log('conditionField...',conditionField,validationResult,cond.values);
          let conditionValidationResult = validationResult;
          const sub_conditions  = (cond.sub_conditions && cond.sub_conditions!==null)?cond.sub_conditions:[];
          // console.log('conditionField1111',sub_conditions);
          sub_conditions.forEach((subCond)=>{
            validationResult = (conditionValidationResult==='')?'true':conditionValidationResult;
            validationResult='(true==='+validationResult+')';
            if(subCond.condition_json.length>0){
              validationResult+=' && (';
            }
            subCond.condition_json.forEach((condJson)=>{
              if(condJson==='and'){
                validationResult+=' &&';
              }else if(condJson==='or'){
                validationResult+=' || ';
              }else{
                if(isSet(condJson.field_label,null)===null){
                  validationResult+='(true===true)';
                }else{
                  const conditionField = getSelectedValueFromForm(formData,{
                    searchBy:'name',fieldName:condJson.field_label,
                    fieldData:condJson,
                    ...defObj
                  });
                  if(condJson.field_label===undefined || condJson.field_label===''){
                    validationResult+='(true===false)';
                  }else if(conditionField.isExist===true){
                    validationResult+=' (true==='+conditionRulesChecking(
                      conditionField,
                      {values:condJson.values,filter:condJson.comparator})+' )';
                  }else{
                    validationResult+='(true===false)';
                  }
                }
              }
            })
            if(subCond.condition_json.length>0){
              validationResult+=')';
            }
            subCond.action_json.forEach((action,actionIndex)=>{
              // console.log('conditionField11111',validationResult);
             
              if(eval("("+validationResult+")")){
                
                if(action.action_type===1){
                  const conditionField = getSelectedValueFromForm(formData,{
                    searchBy:'id',id:action.action_element_id,
                    fieldData:field,
                    ...defObj
                  });
                  // console.log('validationResult',conditionField,validationResult,action);
                  if(conditionField.isExist===true){
                    updateFieldGroups[conditionField.sectionIndex].data[conditionField.fieldIndex].access_mode='EDITABLE';
                    updateFieldGroups[conditionField.sectionIndex].data[conditionField.fieldIndex].quickCreate = true;  
                  }
                  // console.log(conditionField);
                }else if(action.action_type===2){
                  const conditionField = getSelectedValueFromForm(formData,{
                    searchBy:'sectionId',id:action.action_element_id,
                    fieldData:field,
                    ...defObj
                  });
                  if(conditionField.isExist===true){
                    updateFieldGroups[conditionField.sectionIndex].access_mode='EDITABLE';
                  }
                }else if(action.action_type===3){
                  const conditionField = getSelectedValueFromForm(formData,{
                    searchBy:'id',id:action.action_element_id,
                    fieldData:field,
                    ...defObj
                  });
                  if(conditionField.isExist===true){
                    updateFieldGroups[conditionField.sectionIndex].data[conditionField.fieldIndex].required=true;
                  }
                }
              }else{
                // console.log('action',action);
                if(action.action_type===1){
                  const conditionField = getSelectedValueFromForm(formData,{
                    searchBy:'id',id:action.action_element_id,
                    fieldData:field,
                    ...defObj
                  });
                   // console.log('conditionField',updateFieldGroups,conditionField);
                  if(conditionField.isExist===true){
                    updateFieldGroups[conditionField.sectionIndex].data[conditionField.fieldIndex].access_mode='HIDDEN';
                  }
                }else if(action.action_type===2){
                  const conditionField = getSelectedValueFromForm(formData,{
                    searchBy:'sectionId',id:action.action_element_id,
                    fieldData:field,
                    ...defObj
                  });
                  if(conditionField.isExist===true){
                    updateFieldGroups[conditionField.sectionIndex].access_mode='HIDDEN';
                  }
                }else if(action.action_type===3){
                  const conditionField = getSelectedValueFromForm(formData,{
                    searchBy:'id',id:action.action_element_id,
                    fieldData:field,
                    ...defObj
                  });
                  if(conditionField.isExist===true){
                    updateFieldGroups[conditionField.sectionIndex].data[conditionField.fieldIndex].required=false;
                    validationForms[updateFieldGroups[conditionField.sectionIndex].data[conditionField.fieldIndex].id]="";
                  }
                }
              }
            })
          })
        })
      }
    })
    return {updateFieldGroups, updateSubFormData};
  }

  export const setLookupMappingFieldValue = (updatedPreviewItems,dataObject,lookupDependency,sectionType,tabescriptorList)=>{
   
    let clearValidations = [];
    let ElementIdSplit = dataObject.item.id.split("_");
    let ElementId = ElementIdSplit[0];
    // console.log('ElementId',ElementId);
    if(lookupDependency.hasOwnProperty(ElementId )===true){
      if(isSet(dataObject.lookupData,dataObject.LookupData)!==undefined){
        // Field  Mapping for subform lookup fields
        if(sectionType==="subform"){
          Object.entries(lookupDependency[ElementId]).forEach(([fromField,ToField]) =>{
            let fromFieldSplit = fromField.split(".");
            let toFieldValueSplit = ToField.split(".");
            Object.entries(isSet(dataObject.lookupData,dataObject.LookupData)).forEach(([key, Data]) => {
              if(fromFieldSplit[0]===key){
                updatedPreviewItems.map((field)=>{
                  let fieldObj = tabescriptorList.find((i)=>i.id===field.table_descriptor_id);
                  if(field.table_descriptor_id ===toFieldValueSplit[0] &&  Data !== null){
                    if(fieldObj && fieldObj.element==="PickList"){
                      if(fromFieldSplit[1]!==undefined && fromFieldSplit[1]===Data  && toFieldValueSplit[1]!==undefined){
                        field.selected_value = toFieldValueSplit[1];
                        clearValidations.push(field.table_descriptor_id);
                      }else if(Data===''){
                        field.selected_value = "";
                      }
                    }else{
                      field.selected_value = Data;
                      if(field.element==='CheckBoxes'){
                        field.selectedValue = isSet(field.selectedValue,false);
                      }
                      clearValidations.push(field.table_descriptor_id);
                    }
                    // if(fromFieldSplit[1]!==undefined){
                    //   if(fromFieldSplit[1]===Data && toFieldValueSplit[1]!==undefined){
                    //     field.selected_value = toFieldValueSplit[1];
                    //   }else if(Data===''){
                    //     field.selectedValue = "";
                    //   }
                    // }else{
                    //   field.selected_value = Data;
                    // }
                  }
                  return field;
                });
              }
            });
          });
          
        }else{
          //Field mapping for section lookup fields
          //Itterating lookup currenly selected records values
          Object.entries(dataObject.lookupData).forEach(([key, Data]) => {
            // Key {Field ID} Data {Record Actual Value}
            let fieldKey = key;
            if(lookupDependency[ElementId].hasOwnProperty(key+"."+Data)===true){
              fieldKey = key+"."+Data;
            }
            //Checking is lookup dependency field mapping has mapping for the curren itterating field
            // Pick list field mappings are comes with dot(.) seperated [LookupWindowFieldID].[PicklistOptionID or PicklistOption value] :  [currentFormWindowFieldID].[PicklistOptionID or PicklistOption value]
            Object.entries(lookupDependency[ElementId]).forEach(([fromField,ToFieldValue])=>{
              let fromFieldSplit = fromField.split(".");
              let toFieldValueSplit = ToFieldValue.split(".");
              if(fromFieldSplit[0]===fieldKey || fromFieldSplit[0]===key ){
                updatedPreviewItems.map((section)=>{
                  // Itteating field on Itterating section
                  return section.data.map((field)=>{
                    if(field.id===toFieldValueSplit[0] && Data!==null ){                
                      if(field.element==="PickList"){
                          if(fromFieldSplit[1]!==undefined && fromFieldSplit[1]===Data ){
                            field.selectedValue = toFieldValueSplit[1];
                            clearValidations.push(field.id);
                          }else if(Data===''){
                            field.selectedValue = "";
                          }
                      }else{
                        field.selectedValue = Data;
                        if(field.element==='CheckBoxes'){
                          field.selectedValue = isSet(field.selectedValue,false);
                        }
                        clearValidations.push(field.id);
                      }
                    }
                    return field;
                  })
                });
              }
            });
          });
        }
      }
    }
    return {clearValidations,updatedPreviewItems};
  }

   
export const userUtilList = ()=>{
  let userUtilListData = localStorage.getItem('userUtilList');
  userUtilListData = (userUtilListData!==undefined && userUtilListData!==null && userUtilListData!=='')?JSON.parse(userUtilListData):null;
  // console.log(currencyListData);
  if(userUtilListData===null){
    let API_Url = "utils/userutil-data";
    callGET(API_Url)
      .then(res => {
        if(res.status===200){ 
          const response = res.data;
          if(response.code===200){
              const responseData = response.data;
              userUtilListData = responseData;
              localStorage.setItem('userUtilList',JSON.stringify(responseData));
          }
        }     
      })
    .catch(err => {
      console.log(err);
    })
  }
  return userUtilListData;

}
  // CURRENCY LIST
export const currencyListUtil = ()=>{
  let currencyListData = localStorage.getItem('currencyList');
  currencyListData = (currencyListData!==undefined && currencyListData!==null && currencyListData!=='')?JSON.parse(currencyListData):[];
  // console.log(currencyListData);
  if(currencyListData.length===0){
    let API_Url = "utils/currency-list";
    callGET(API_Url)
      .then(res => {
        if(res.status===200){ 
          const response = res.data;
          if(response.code===200){
              const responseData = response.data;
              currencyListData = responseData;
              localStorage.setItem('currencyList',JSON.stringify(responseData));
          }
        }     
      })
    .catch(err => {
      console.log(err);
    })
  }
  return currencyListData;

}
  // WINDOWS LIST
  export const windowsListUtil = ()=>{
    let windowsListData = localStorage.getItem('windowsList');
    windowsListData = (windowsListData!==undefined && windowsListData!==null && windowsListData!=='')?JSON.parse(windowsListData):[];
    if(windowsListData.length===0){
      const queryString = '?query=&page=0&orderBy=&size=100&direction=';
      callGET("windows/list"+queryString)
        .then(res => {
          if(res.status===200){ 
            const response = res.data;
            if(response.code===200){
                const responseData = response.data;
                let windowListData = response.data.windows.content;
                let windowsList = [{
                  windowName:'-None-',
                  id:''
                }]
                windowListData.sort((a, b) => (a.display_priority > b.display_priority) ? 1 : -1)
                windowListData.forEach((arr,i) => {
                  windowsList.push({
                    windowName:arr.display_name,
                    id:arr.id
                  })
                });
              localStorage.setItem('windowsList',JSON.stringify(windowsList));
            }
          }     
        })
      .catch(err => {
        console.log(err);
      })
    }
    return windowsListData;
  }

  export const findFiltersByFieldIdWithFieldArrCustom = (fieldId, windowFields, fieldFilter,masterWinFields=[]) => {
    let data = [];
    const fieldGroups = windowFields;
    // console.log('fieldGroups',fieldGroups,fieldId);
    if(fieldGroups) {
      let bol = false;
      for (var i = 0; i < fieldGroups.length; i++) {
        // for (var j = 0; j < fieldGroups[i].data.length; j++) {
          if(data.length < 1) {
            if(fieldGroups[i].id === fieldId) {
              data = fieldFilerFindByIdFull(fieldFilter,fieldGroups[i].id);
              bol = true;
              break;
            }else if(fieldGroups[i].dependent_layout) {
                data = findFiltersByFieldIdWithFieldArrRecuresiveCustom(fieldId,fieldGroups[i].dependent_layout.fields_with_filters.window_fields,fieldGroups[i].dependent_layout.fields_with_filters);
                // console.log('Object.keys(data)',Object.keys(data).length,data);
                if(data.length > 0 || Object.keys(data).length>0) {
                  // console.log('DataChange',true);
                  bol = true;
                  break;
                }
                // else{
                //   if(fieldId,fieldGroups[i].dependent_layout.window_id===fieldId){
                //     data = fieldGroups[i].dependent_layout;
                //     console.log('dataww2ww',fieldGroups[i].dependent_layout);
                //     bol = true;
                //     break;
                //   }
              // }
            }
          }
        
        if(bol) {
          break;
        }
        
      }
    }
    // console.log('DataChange',data);
    return data;
  }

  export const findFiltersByFieldIdWithFieldArrRecuresiveCustom = (fieldId, windowFields, fieldFilter) => {
    let data = [];
    const fieldGroups = windowFields;
    if(fieldGroups) {
      let bol = false;
      for (var i = 0; i < fieldGroups.length; i++) {
        // for (var j = 0; j < fieldGroups[i].data.length; j++) {
          if(fieldGroups[i].id === fieldId) {
            data = fieldFilerFindByIdFull(fieldFilter,fieldGroups[i].id);
            bol = true;
            break;
          }else if(fieldGroups[i].dependent_layout) {
            data = findFiltersByFieldIdWithFieldArrRecuresive(fieldId,fieldGroups[i].dependent_layout.fields_with_filters.window_fields,fieldGroups[i].dependent_layout.fields_with_filters);
            //if(data.length > 0) {
            if(Object.keys(data).length > 0) {
              bol = true;
              break;
            }
          }
        // }
        if(bol) {
          break;
        }         
      }
    }
    return data;
  }

  export const findFiltersByFieldIdWithFieldArr = (fieldId, windowFields, fieldFilter,masterWinFields=[]) => {
    let data = [];
    const fieldGroups = windowFields;
    // console.log('fieldGroups',fieldGroups,fieldId);
    if(fieldGroups) {
      let bol = false;
      for (var i = 0; i < fieldGroups.length; i++) {
        // for (var j = 0; j < fieldGroups[i].data.length; j++) {
          if(data.length < 1) {
            if(fieldGroups[i].id === fieldId) {
              data = fieldFilerFindById(fieldFilter,fieldGroups[i].id);
              bol = true;
              break;
            }else if(fieldGroups[i].dependent_layout) {
                data = findFiltersByFieldIdWithFieldArrRecuresive(fieldId,fieldGroups[i].dependent_layout.fields_with_filters.window_fields,fieldGroups[i].dependent_layout.fields_with_filters);
                // console.log('Object.keys(data)',Object.keys(data).length,data);
                if(data.length > 0 || Object.keys(data).length>0) {
                  // console.log('DataChange',true);
                  bol = true;
                  break;
                }
                // else{
                //   if(fieldId,fieldGroups[i].dependent_layout.window_id===fieldId){
                //     data = fieldGroups[i].dependent_layout;
                //     console.log('dataww2ww',fieldGroups[i].dependent_layout);
                //     bol = true;
                //     break;
                //   }
              // }
            }
          }
        // }
        // if(bol===false){
        //   //GET FIELD DETAILS FROM MASTER WINDOW
        //   isSet(masterWinFields.master_window_layouts,[]).map((masterWin)=>{
        //     const masterFieldIndex = masterWin.fields_with_filters.window_fields.findIndex(item => { return (item.id===fieldId) });
        //     console.log('masterFieldIndex',masterFieldIndex);
        //     if(masterFieldIndex!==-1){
        //       data = fieldFilerFindById(masterWin.fields_with_filters,masterWin.fields_with_filters.window_fields[masterFieldIndex].id);
        //       bol = true;
        //     }
        //   })
        // }
        if(bol) {
          break;
        }
        /*for (var j = 0; j < fieldGroups[i].data.length; j++) {
          if(data.length < 1) {
            if(fieldGroups[i].data[j].id === fieldId) {
              data = fieldFilerFindById(fieldFilter,fieldGroups[i].data[j].id);
              bol = true;
              break;
            }else if(fieldGroups[i].data[j].dependent_layout) {
              data = findFiltersByFieldIdWithFieldArrRecuresive(fieldId,fieldGroups[i].data[j].dependent_layout.fieldGroups,fieldGroups[i].data[j].dependent_layout.fields_with_filters);
              // console.log(data);
              if(data.length > 0) {
                bol = true;
                break;
              }
            }
          }
        }
        if(bol) {
          break;
        }*/
      }
    }
    // console.log('DataChange',data);
    return data;
  }

  export const findFiltersByFieldIdWithFieldArrRecuresive = (fieldId, windowFields, fieldFilter) => {
    let data = [];
    const fieldGroups = windowFields;
    if(fieldGroups) {
      let bol = false;
      for (var i = 0; i < fieldGroups.length; i++) {
        // for (var j = 0; j < fieldGroups[i].data.length; j++) {
          if(fieldGroups[i].id === fieldId) {
            data = fieldFilerFindById(fieldFilter,fieldGroups[i].id);
            bol = true;
            break;
          }else if(fieldGroups[i].dependent_layout) {
            data = findFiltersByFieldIdWithFieldArrRecuresive(fieldId,fieldGroups[i].dependent_layout.fields_with_filters.window_fields,fieldGroups[i].dependent_layout.fields_with_filters);
            //if(data.length > 0) {
            if(Object.keys(data).length > 0) {
              bol = true;
              break;
            }
          }
        // }
        if(bol) {
          break;
        }
         /*for (var j = 0; j < fieldGroups[i].data.length; j++) {
            if(fieldGroups[i].data[j].id === fieldId) {
              data = fieldFilerFindById(fieldFilter,fieldGroups[i].data[j].id);
              bol = true;
              break;
            }else if(fieldGroups[i].data[j].dependent_layout) {
              data = findFiltersByFieldIdWithFieldArrRecuresive(fieldId,fieldGroups[i].data[j].dependent_layout.fieldGroups,fieldGroups[i].data[j].dependent_layout.fields_with_filters);
              if(data.length > 0) {
                bol = true;
                break;
              }
            }
        }
        if(bol) {
          break;
        }*/
      }
    }
    return data;
  }

  export const fieldFilerFindById = (fields_with_filters,fieldId)=>{
        // const {fieldDetails} = this.props;
        let returnData = {};
        if(fields_with_filters.window_fields!==undefined)
        fields_with_filters.window_fields.forEach((item)=>{
            if(item.id===fieldId){
              // returnData = item.filters
              // console.log(item);
                returnData = {
                    filters:item.filters,
                    api_field_name:item.api_field_name,
                    field_name:item.field_name,
                    field_type:item.field_type,
                    fieldTypeId:item.fieldTypeId,
                    options:item.options,
                    lookup_window_name:item.lookup_window_name,
                    dependent_layout:item.dependent_layout
                }
            }
        });
        return returnData;
    }

  export const fieldFilerFindByIdFull = (fields_with_filters,fieldId)=>{
        // const {fieldDetails} = this.props;
        let returnData = {};
        if(fields_with_filters.window_fields!==undefined)
        fields_with_filters.window_fields.forEach((item)=>{
            if(item.id===fieldId){
              // returnData = item.filters
              // console.log(item);
                returnData = {item}
            }
        });
        return returnData;
    }

  export const prepareOptionArr = (data) => {
      // console.log(data);
    let optionsArr = [];
    if(data) {
      if(data.length > 0) {
            data.forEach((arr,i) => {
              const value = {
                "value": arr.key,
                "label": arr.value,
              }
              optionsArr.push(value);
              return true;
            }) 
          }
        }
    return optionsArr;
   }

  export const findFiltersByValueAndFilterArray = (value, windowFieldsArray) => {
    let data = [];
    const fieldGroups = windowFieldsArray;
    if(fieldGroups) {
        let bol = false;
        for (var i = 0; i < fieldGroups.length; i++) {
         for (var j = 0; j < fieldGroups[i].data.length; j++) {
            if(fieldGroups[i].data[j].value === value) {
                data = fieldFilerFindByValue(fieldGroups[i].data,fieldGroups[i].data[j].value);
                //data = fieldFilerFindByValue(fieldGroups[i].data,fieldGroups[i].data[j].value);
                bol = true;
                break;
            }else if(fieldGroups[i].data[j].dependent_layout) {
                data = findFiltersByValueAndFilterArray1(value,fieldGroups[i].data[j].dependent_layout.fieldGroups,fieldGroups[i].data[j].dependent_layout.fields_with_filters);
                console.log(data);
                if(data.length > 0) {
                  bol = true;
                  break;
                }
            } 
        }
        if(bol) {
          break;
        }
      }
    }
    return data;
  }

  export const findFiltersByValueAndFilterArray1 = (value, windowFields, fieldFilter) => {
    let data = [];
    const fieldGroups = windowFields;
    if(fieldGroups) {
          let bol = false;
          for (var i = 0; i < fieldGroups.length; i++) {
         for (var j = 0; j < fieldGroups[i].data.length; j++) {
            if(fieldGroups[i].data[j].id === value) {
                    data = fieldFilerFindByValue(fieldGroups[i].data,fieldGroups[i].data[j].value);
                    //data = fieldFilerFindByValue(fieldGroups[i].data,fieldGroups[i].data[j].value);
                    bol = true;
                    break;
                  }else if(fieldGroups[i].data[j].dependent_layout) {
                    data = findFiltersByValueAndFilterArray1(value,fieldGroups[i].data[j].dependent_layout.fieldGroups,fieldGroups[i].data[j].dependent_layout.fields_with_filters);
                    if(data.length > 0) {
                      bol = true;
                      break;
                    }
                  }
        }
        if(bol) {
          break;
        }
      }
    }
    return data;
  }

  export const fieldFilerFindByValue = (fieldGroups,value)=>{
    // const {fieldDetails} = this.props;
    let returnData = {};
    if(fieldGroups !== undefined)
    fieldGroups.forEach((item)=>{
        if(item.value===value){
          // returnData = item.filters
            returnData = {
                /*filters:item.filters,
                api_field_name:item.api_field_name,
                field_name:item.field_name,
                field_type:item.field_type,
                fieldTypeId:item.fieldTypeId,
                options:item.options*/
                //field_name : item.element
                field_name : item.label.blocks[0].text
            }
        }
    });
    return returnData;
  }


  
  export const findFiltersOjectByFilterIdAndFilterArray = (filterId, filterArray) => {
    // console.log(filterId,filterArray);
    let data = [];
    if(filterArray) {
      filterArray.forEach((arr,i) => {
        if(arr.filterId === filterId) {
          data = arr;
        }
      })  
    }
    return data;
  }

  export const findFiltersOjectByFilterNameAndFilterArray = (filterId, filterArray) => {
    // console.log(filterId,filterArray);
    let data = [];
    if(filterArray) {
      filterArray.forEach((arr,i) => {
        if(arr.name === filterId) {
          data = arr;
        }
      })  
    }
    return data;
  }

  export const findFieldWithFilterByName = (windArr, name) => {
    let data = null;
    if(windArr) {
      windArr.forEach((arr,i) => {
        if(arr.api_field_name === name) {
          data = arr;
        }
      })
    }
    return data;
  }

  export const validateEmail = (inputMail) => {
    let isValid = true;
    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    if (!pattern.test(inputMail)) {
        isValid = false;        
    } 
    return isValid; 
  }

  export const prepareOptionUserArr = (data) => {
    console.log(data);
    let optionsArr = [];
    if(data) {
      if(data.length > 0) {
            data.forEach((arr,i) => {
              const value = {
                "value": arr.id,
                "label": arr.last_name+' '+arr.first_name
              }
              optionsArr.push(value);
              return true;
            }) 
          }
        }
    return optionsArr;
   }

  export const getWindowDataUsingId = (id) => {
    let data = {};
    const profileInfo = getProfileAuthorities();
    profileInfo.data.user_profile_layout.forEach((arr1,ind1) => {
      if(arr1.window_id === id) {
        data = arr1;
      }
    })
    return data;
  }

  export const getPdfPreferenceByWindowId = (windowId) => {
    let data = [];
    const info = getUserInfo().data.user_preference;
    // console.log('info',info);
    if(info!==undefined && info.pdf_preview_preferences!==undefined) {
      info.pdf_preview_preferences.forEach((arr,ind) => {
        if(arr[windowId]) {
          let pdfPref = arr[windowId];
          // console.log('pdfPref11',pdfPref);
          // pdfPref = pdfPref.map((item)=>{
          //   return {id:item,count:1};
          // });
          data = pdfPref;;
        }
      })
    }
    return data;
  }

  export const capitalizeFirstLetter = (text) => {
    let returnData = '';
    if(text) {
      returnData = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    return returnData;
  }
  export const convertStrToArrWithSeparator = (string,separator=',') =>{
    if(typeof string !== 'boolean'){
      const arr = isSet(string, '').split(separator);
      return isSet(arr,[]).filter(i => isSet(i, null) !== null);
      // const arr = isSet(string,'').split(separator);
      // return arr.filter((i=>{
      //   if(isSet(arr,null)!==null){
      //     return i;
      //   }
      // }));
    }else{
      let returnArr =[];
      returnArr.push(string.toString());
      return returnArr;
     }
  }


  export const getWindowFieldsUsingFieldName = (fieldName,windowFields) => {
    let returnData = null;
    if(windowFields && windowFields.fields_with_filters && windowFields.fields_with_filters.window_fields) {
        windowFields.fields_with_filters.window_fields.forEach((fItem) => {
            if(fItem.api_field_name === fieldName || fItem.field_name === fieldName) {
                returnData = fItem;
            }
        })
    }
    return returnData;
  }

  
  export const getOptionsNameUsingVal = (arrOpt,val) => {
    let returnData = '';
    if(arrOpt) {
      arrOpt.forEach((item,ind)=>{
       if(val === item.value) {
        returnData = item.label;
       }
      })
    }
    return returnData;
  }

  export const getOptionsDataUsingVal = (arrOpt,val) => {
      let returnData = '';
      if(arrOpt) {
        arrOpt.forEach((item,ind)=>{
         if(val === item.value) {
          returnData = item;
         }
        })
      }
      return returnData;
    }

  export const getValueFromArrayObject = (data) => {
    let returnVal = [];
    if(data) {
      data.forEach((obj) => 
        Object.entries(obj).forEach(([key, value]) => 
        returnVal.push(value))
      );
    }
    return returnVal;
  }

  export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  export const getValueFromOptions = (val,options) => {
    let returnVal = null;
    if(options) {
      options.forEach((item) => {
        if(item.value === val) {
          returnVal = item;
        }
      })
    }
    return returnVal;
  }


  export const isSet =(val,def,type='')=>{
    const decimalPointFields = ['Currency','Decimal','Number','LongNumber'];
    if(decimalPointFields.indexOf(type)!==-1 && val!==undefined && val!=='undefined' && val!=='' && val!==null){
      if(isSet(val,'')===0){
        return def;
      }
      return isSet(val,'');
    }else if((val!==undefined && val!=='undefined' && val!=='' && val!==null && type!=='ARRAY') || (type==='ARRAY' && isSet(val,[]).length!==0)){
      return val;
    }
    return def;
  } 
  export const isObject = (o)=> {
    return o instanceof Object && o.constructor === Object;
  }

  export const isEmptyValueExist = (options) => {
    let returnVal = false;
    try {
      if(options) {
        options.forEach((item) => {
          if(item.value === '') {
            returnVal = true;
          }
        })
      }
    } catch (error) {
      returnVal = false;
    }
    return returnVal;
  }

  export const numericValidationWithDot = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const re  = /^\-?\d*\.?\d*$/;
    // const re  = new RegExp(/^\-?\d*\.?\d*$/, 'gi')
    if (!re.test(keyValue)){
      event.preventDefault();
    }
  }

  export const numericValidationWithDotWithoutNegative = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const re  = /^\d*\.?\d*$/;
    // const re  = new RegExp(/^\-?\d*\.?\d*$/, 'gi')
    if (!re.test(keyValue)){
      event.preventDefault();
    }
  }

  export const numericValidation = (event) => {
    const keyCode = event.keyCode || event.which;
    // const keyValue = String.fromCharCode(keyCode);
    if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
      event.preventDefault();
    }
  }

  export const formatStringToCamelCase = (str) => {
    let camelCased = str.replace(/_([a-z])/g, function (g) { return g[1].toUpperCase(); });
    return camelCased
  }

  export const searchFuntion = (value,type) => {
    let filter = value.toLowerCase();
    $("."+type).each(function () {
        if ($(this).text().toLowerCase().search(new RegExp(filter, "i")) < 0) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });
  }

  export const dateValidation = (stringToValidate) => {
    let isValid = false;
    try{
      let regex = /^[0-9-+()/]*$/;
      isValid = regex.test(stringToValidate);
    } catch (error) {
      isValid = true;
    }
    return isValid;
  }

  export const dateTimeValidation = (stringToValidate) => {
    let isValid = false;
    try{
      let regex = /^[0-9-+()/: ]*$/;
      isValid = regex.test(stringToValidate);
    } catch (error) {
      isValid = true;
    }
    return isValid;
  }  

  export const findArrayIndex = (val,items) => {
    let returnVal = -1;
    if(items) {
      items.forEach((item,ind) => {
        if(item.table_descriptor_id === val) {
          returnVal = ind;
        }
      })
    }
    return returnVal;
  }

  export const roundOffTwoDecimal = (val) => {
    let returnVal = '';
    try{
      returnVal = val.toFixed(2);
    } catch (error) {
      returnVal = val;
    }
    return returnVal;
   }

   export const convertSystemDateFormat = (val) => {

    let returnVal = val;
    try {
      returnVal = moment(val).format('yyyy-MM-DD HH:mm:ss');
      // console.log('convertSystemDateFormat',returnVal)
      console.log(moment(val).isValid());
      if(returnVal === 'Invalid date') {
        returnVal = val;
      }
    } catch (err) {
      returnVal = val;
      // console.log('convertSystemDateFormat',returnVal)
    }
    return returnVal;
   }

   export const phoneNumberValidation = (e) => {
    // const {value} = e.target;
    const keyCode = e.which;
    const supportCharacter = [45,40,41,43]
    if ((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && supportCharacter.indexOf(keyCode) === -1) {
      e.preventDefault();
    }
   }

   export const checkViolationsExist = (key, violations) => {
    let returnVal = false;
    if(violations) {
      if(violations[key]) {
        returnVal = true;
      }
    }
    return returnVal;
   }

   export const getViolationsMsg = (key, violations) => {
    let returnVal = '';
    if(violations) {
      if(violations[key]) {
        returnVal = violations[key];
      }
    }
    return returnVal;
   }

   export const deleteViolationsMsg = (key, violations) => {
    if(violations) {
      if(violations[key]) {
        delete violations[key];
      }
    }
    return violations;
   }


  //  
    
  export const getMetaTableData = (windowName,formId)=>{
    const profileInfo = getProfileAuthorities();
    const windowList = windowsMenusList();
    let returnData = {
      isExist:false,
    };
   if(formId===null){ return false; }
    try{
      windowList.data.forEach((module)=>{
        module.windows.forEach((win)=>{
          if(win.window_name===windowName){
            if(profileInfo!==undefined && profileInfo.data!==undefined && profileInfo!=='' && profileInfo.data!==''){
              profileInfo.data.user_profile_layout.forEach((item)=>{
                // console.log("windowName",win.window_id,item.window_id)
                if(win.window_id===item.window_id){
                  let API_Url ="table-data-engine/"+windowName+"/"+item.layout_id+"/"+formId;
                  // console.log('Layout...',API_Url)
                  callGET(API_Url)
                  .then(res => {
                    if(res.status===200){ 
                      const response = res.data;
                      if(response.code===200){
                        const responseData = response.data;
                        returnData = {
                          isExist:true,
                          data:responseData
                        }
                        // console.log('LayoutRules...',responseData);
                        // let layoutObject = {
                        //   id:responseData.id,
                        //   layout_name:responseData.layout_name,
                        //   module_id: responseData.module_id,
                        //   window_id: responseData.window_id,
                        //   master_detail_windows:responseData.master_detail_windows,
                        //   master_detail_window_value_json_model:responseData.master_detail_window_value_json_model,
                        //   record_owner_info:responseData.record_owner_info,
                        //   score:responseData.score,
                        //   converted : responseData.converted,
                        //   is_active:responseData.is_active,
                        // };
                      // let subformobj = null;
                      // let updateFieldGroups = responseData.fieldGroups.map((section,secIndex)=>{
                      //     return {
                      //       ...section,
                      //       section_index:secIndex,
                      //     }
                      // });
                      // let nonFieldGroups = responseData.nonFieldGroups.map((section)=>{
                      //   section.refLookup = true;
                      //   return section;
                      // });
                       
                      }
                    }
                  })
                  .catch(err => {
                    console.log(err);
                  })
                }
              })
            }
          }
        })
      })
     
    }catch(e){

    }
    return returnData;
  }

  export const getIntersectedData = (actionData,field) => {
    let finalArr = [];
    let finalArrName = [];
    let availableActions = [];
    let valArr = [];
    let isAccess = true;
    Object.entries(actionData).forEach(([key, value]) => {
      let val = value[field];
      if(value.access_mode === false) {
        isAccess = false;
      }
      valArr.push(val);
      val.forEach(item => {
        finalArr.push(item);
        finalArrName.push(item.name)
      })
      
    });
    // console.log('valArr',valArr)
    var keys = Object.keys(actionData);
    if(keys.length <= 1) {
      availableActions = finalArr;
    }else {
      let names=[];
      valArr.forEach(item => {
        let vals = [];
        item.forEach(item1 => {
          vals.push(item1.name);
        })
        names.push(vals);
        
      });

      let result = names.shift().filter(function(v) {
        return names.every(function(a) {
            return a.indexOf(v) !== -1;
        });
      });

      let actionObj = {};
      finalArr.forEach(item => {
        if(result.indexOf(item.name) !== -1)
          actionObj[item.name] = item;
      })

      for(var i in actionObj) {
        availableActions.push(actionObj[i]);
      }
    }
    
    availableActions.forEach(item => {
      if(item.name==='Activate'){
        item.access_mode = isAccess?true:false;
      }

      if(item.name==='Inactivate'){
        item.access_mode = isAccess?true:false;
      }

      if(item.name==='Change Owner'){
        item.access_mode = isAccess?true:false;
      }

      if(item.name==='Edit' || item.name==='Delete' || item.name==='Change Owner') {
        item.access_mode = isAccess?true:false;
      }
    })
    // console.log(availableActions);
    return availableActions;
  }

  export const getIntersectedData1 = (actionData,field) => {
    let finalArr = [];
    let finalArrName = [];
    let availableActions = [];
    Object.entries(actionData).forEach(([key, value]) => {
      let val = value[field];
      val.forEach(item => {
        finalArr.push(item);
        finalArrName.push(item.name)
      })
      
    });

    var keys = Object.keys(actionData);
    if(keys.length <= 1) {
      availableActions = finalArr;
    }else {
      var uniq = finalArrName
      .map((name) => {
        return {
          count: 1,
          name: name
        }
      })
      .reduce((a, b) => {
        a[b.name] = (a[b.name] || 0) + b.count
        return a
      }, {})

      var duplicates = Object.keys(uniq).filter((a) => uniq[a] > 1)

      let actionObj = {};
      finalArr.forEach(item => {
        if(duplicates.indexOf(item.name) !== -1)
          actionObj[item.name] = item;
      })

      for(var i in actionObj) {
        availableActions.push(actionObj[i]);
      }
    }

    return availableActions;
  }

  export const isActionComponentEnabled = (actionName, options,actionButtons = []) => {
    let returnVal = true;
    if(options) {
      options.forEach(item => {
        if(item.authority_name === actionName) {
          returnVal = item.is_selected;
        }
      })
    }
    if(actionButtons &&  actionButtons.length>0){
      returnVal = (actionButtons.find(i=>i?.component_name===actionName || i?.display_name===actionName)===undefined)?'false':returnVal;
    }
    return returnVal;
  }

  export const valueFromId = (opts, id) =>  {
   let returnVal = '';
    const test =  opts.find(o => o.value === id)
   if(test !== undefined) {
    returnVal = test.value;
   }else{
    opts.forEach((itm)=>{
        const test =  isSet(itm.options,[]).find(o => o.value === id);
        if(test && test.value) {
          returnVal = test.value;
         }
    })
   }
   return returnVal;
  }

  export const decimalOptions = (maxInt)=>{
    const items = []
    const maxDecLimit = (maxInt<=10) ? maxInt:10;
    for (let maxDec=0; maxDec<maxDecLimit;maxDec++){
      items.push(maxDec);
    }
    return items;
  }

  export const callDownloadPDF = (url, fileName="sample.pdf") => {
    // console.log('callDownloadPDFurl',url);
    return new Promise((resolve, reject) => {
      axios.get(url, {
        responseType: 'arraybuffer', // Handle byteArray from server
      })
      .then((res) => {
        // console.log('callDownloadPDFurl res',res);
        if(isSet(res.data.data,null)!==null){
          const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/pdf' });
          fileDownload(blob, fileName); // Trigger the download using fileDownload
        }else{
          // console.log('arraysystem...');
          document.location.href = url;
        }
        resolve();
      })
      .catch((error) => {
        console.error("Error downloading file: ", error);
        reject("File not found");
      });
    });
    // axios.get(url, {
    //   responseType: 'blob',
    // })
    // .then((res) => {
    //   fileDownload(res.data,fName)
    // })
  };
   
  export const convertDefaultDateFormat = (dateStr, formatType="Date") => {
     let returnVal = dateStr;
    
     try {
      // if(moment(dateStr).isValid() === true) {
        if(formatType === "Date") {
          returnVal = moment(dateStr, ShipConstants.DEFAULT_DATE_FORMAT).format(ShipConstants.DEFAULT_DATE_FORMAT);
        }else {
          returnVal = moment(dateStr, getDateFormat('DateTime')).format(ShipConstants.DEFAULT_DATETIME_FORMAT);
        }
        console.log(dateStr,moment(dateStr).isValid(),returnVal,formatType,getDateFormat());
        if(returnVal === "Invalid date") {
          returnVal = dateStr;
        }
      // }
     }catch (e) {
       returnVal = dateStr;
     }
    
    return returnVal;
  }


  export const  getQueryVariable = (queryStr)=> {
    let query = [];
    let queryStrSplit = queryStr.split('?');
    let queryString = isSet(queryStrSplit[1],'');
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        if(isSet(decodeURIComponent(pair[0]),null)!==null){
          query.push({
            'key':decodeURIComponent(pair[0]),
            'value':decodeURIComponent(pair[1] || '')
          });
        }
    }
    return {url:isSet(queryStrSplit[0],''),query:query};
}

//GET Excel type Alphabets array for Rate sheet
export const genCharArrayData = (num)=> {
  if(num <= 0) {
    return [];
  }
  var str = num.toString(26);
  var arr = str.split('').forEach(char => {
    var code = char.charCodeAt(0);
    if(code >= 48 && code <= 57) {
      code += 16; // convert 1-9 to A-I and 0 to @
    } else {
      code -= 23; // convert a-p to J-Z
    }
    return code;
  });

  // convert 'A@' to 'Z', 'B@' to 'AZ', etc. 
  // ascii code of '@' is 64
  var index = isSet(arr,[]).indexOf(64)
  while(index >= 0) {
    if(index === 0) {
      arr.shift();  // remove head '@'
    } else {
      arr[index] += 26;
      arr[index - 1]--;
    }
    index = arr.indexOf(64);
  }

  var chars = isSet(arr,[]).map(code => String.fromCharCode(code));
  return chars.join('');
  
}
//GET Excel type Alphabets array for Rate sheet
export const  genHeaderChars = (length)=>{
  let arr = [];
  for (var i=1; i <= length; ++i) {
    arr.push(genCharArrayData(i));
  }
  return arr;
}


export const isDate = (sDate) => {  
  if(isSet(sDate,'').toString() === parseInt(isSet(sDate,'')).toString()) return false; 
  var tryDate = new Date(sDate);
  return (tryDate && tryDate.toString() !== "NaN" && tryDate !== "Invalid Date");  
}

export const isEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

export const setArrayIndexes = (obj) => {
        if(obj) {
            if(obj.fields && obj.fields.length > 0) {
                obj.fields.forEach((fieldArr,fieldInd) => {
                    fieldArr.indexes = ','+fieldInd;
                    fieldArr.displayPosition=fieldInd+1;
                    if(fieldArr.fields && fieldArr.fields.length > 0) {
                        recursiceSetArrayIndexes(fieldArr,fieldArr.indexes);
                    }
                })
            }
        }
        return obj;
    }

export const recursiceSetArrayIndexes = (obj,indexes) => {
        // console.log(obj);
        if(obj) {
            if(obj.fields && obj.fields.length > 0) {
                obj.fields.forEach((fieldArr,fieldInd) => {
                    fieldArr.indexes = ','+indexes+','+fieldInd;
                    fieldArr.displayPosition=fieldInd+1;
                    if(fieldArr.fields && fieldArr.fields.length > 0) {
                        recursiceSetArrayIndexes(fieldArr,fieldArr.indexes);
                    }
                })
            }
        }
    }

export const prepareApiName = (fields) => {
  if(fields && fields.length>0) {
      fields.forEach(item => {
          if(!item.api_name && item.api_name === undefined) {
              item.api_name = item.name ? item.name.trim().replace(/ /g, "_").toLowerCase() : "";
          }
          if(item.fields && item.fields.length>0) {
              prepareApiName(item.fields);
          }
      })
  }
  return fields;
}   

export const whiteSpaceManager = (value)=>{
  let firstLetter = value[0];
  let lastLetter = value[value.length - 1];
  let secondLastLetter = value[value.length - 2];
  let finalLetter = lastLetter+secondLastLetter;
  if ((firstLetter!==' ')&&(finalLetter!=='  ')) {    
    return value.replace(/\t/g, '');
  }else{
    return value.trim();
  }
}

export const mappindFieldTypeGroup = (fieldType) => {
  let returnData = null;
  switch(fieldType) {
    case "TextInput" :
      returnData = {
        warnings:[],
        fields: ["TextInput","TextArea"]
      }
      break;
    case "TextArea" :
      returnData = {
        warnings:[{
          field : "TextInput",
          message : "Show a warning as Maximum of 255 charcters are allowed"
        }],
        fields: ["TextArea","TextInput"]
      }
      break;
    case "PickList" :
      returnData = {
        warnings:[{
          field : "Picklist",
          message : "Mapping of Each data for both the picklist need to be provided"
        },{
          field : "MultiSelect",
          message : "Mapping need to be provided for One to many data"
        }],
        fields: ["PickList","MultiSelect"]
      }
      break;
    case "Barcode" :
      returnData = {
        warnings:[{
          field : "Barcode",
          message : "If both the Barcode Format is same or else dont show"
        }],
        fields: ["Barcode"]
      }
      break;
    case "MultiSelect" :
      returnData = {
        warnings:[{
          field : "Picklist",
          message : "Mapping need to be provided only for many data to one data."
        },{
          field : "MultiSelect",
          message : "Mapping need to provided,for selecting multiple data"
        }],
        fields: ["PickList","MultiSelect"]
      }
      break;
    case "Email" :
      returnData = {
        warnings:[],
        fields: ["Email","TextInput","TextArea"]
      }
      break;
    case "Phone" :
      returnData = {
        warnings:[],
        fields: ["TextInput","Phone"]
      }
      break;
    case "CheckBoxes" :
      returnData = {
        warnings:[],
        fields: ["CheckBoxes"]
      }
      break;
    case "Number" :
      returnData = {
        warnings:[{
          field : "Decimal",
          message : "Check what is the maximum number of digit Decimal will allow,depends on that show the warning"
        }],
        fields: ["Number","Decimal","LongNumber"]
      }
      break;
    case "Date" :
      returnData = {
        warnings:[{
          field : "TextInput",
          message : "Show the warning that again the Date will not be converted to Date field "
        }],
        fields: ["Date","DateTime","TextInput"]
      }
      break;
    case "DateTime" :
      returnData = {
        warnings:[{
          field : "TextInput",
          message : "Show the warning that again the Date will not be converted to Date field "
        },{
          field : "Date",
          message : "Show the warning Time will be removed from the field"
        }],
        fields: ["Date","DateTime","TextInput"]
      }
      break;
    case "Percentage" :
      returnData = {
        warnings:[],
        fields: ["Percentage"]
      }
      break;
    case "Currency" :
      returnData = {
        warnings:[],
        fields: ["Currency"]
      }
      break;
    case "Decimal" :
      returnData = {
        warnings:[{
          field : "Number",
          message : "Check NUMBER INPUT allows decimal.If then, Show the warning that decimal places will be rounded.Rounding need to happen according to the TO field"
        },{
          field : "LongNumber",
          message : "Show the warning that decimal places will be rounded.Rounding need to happen according to the TO field"
        }],
        fields: ["Decimal","Number","LongNumber"]
      }
      break;
    case "LongNumber" :
      returnData = {
        warnings:[{
          field : "Number",
          message : "Check the maximum number of Input number"
        }],
        fields: ["Decimal","Number","LongNumber"]
      }
      break;
    case "Lookup" :
      returnData = {
        warnings:[{
          field : "Lookup",
          message : "Lookup fields need to be mapped "
        }],
        fields: ["Lookup","MultiLookup"]
      }
      break;
    case "MultiLookup" :
      returnData = {
        warnings:[{
          field : "MultiLookup",
          message : "Multi Lookup fields need to be mapped "
        }],
        fields: ["MultiLookup"]
      }
      break;
    case "AutoNumber" :
      returnData = {
        warnings:[],
        fields: ["TextInput"]
      }
      break;
    case "ImageUpload" :
      returnData = {
        warnings:[],
        fields: ["ImageUpload"]
      }
      break;
    case "User" :
      returnData = {
        warnings:[],
        fields: ["User"]
      }
      break;
    case "Reminder" :
      returnData = {
        warnings:[],
        fields: []
      }
      break;
    case "Blank" :
      returnData = {
        warnings:[],
        fields: []
      }
      break;
    default :
      returnData = {
        warnings:[],
        fields: [fieldType]
      };
  }
  return returnData;
}
const equalIgnoreCase=(string1, string2)=>{
  let returnVal = false;
  if(string1?.toLowerCase() === string2?.toLowerCase()){
    returnVal = true
  }
  return returnVal;
}
export {equalIgnoreCase};


//FIND AND MERGE NON-GRO USING ID FROM FILDER-GROUPS
export const addExtraFieldGroup = (extraFields,configField)=>{
    if(extraFields!==undefined)
    extraFields.forEach((item)=>{
            configField.push({
                id:item.id,
                element:item.variable_type,
                filters:item.filters,
                api_field_name:item.variable_name,
                field_name:item.variable_name,
                field_type:item.fieldtype_name, //variable_type
                fieldTypeId:item.id,
                level:0,
                function_type:item.function_type,
                fieldName:item.variable_name,
                isDepenedField:false,
                depenedFields:[],
                options:[],
                is_custom_field : true,
                is_master_window : false,
                dependent_layout : recursiveFields(item),
                lookup_window_name:(item.fields && item.fields.length>0)?item.variable_name:'',
                system_window_name:(item.fields && item.fields.length>0)?item.variable_name:null,
                variable_field_id_path:item.id
            })
    });
    return configField;
}

export const recursiveFields = (item,rateVariablePath='') => {
    let fields = null;
    //if(item.fieldtype_name === "Array") {
    if(item.fields && item.fields.length>0) {
        let ratePath = (rateVariablePath!=='')?rateVariablePath:item.id;
        fields = {
          id:item.id,
          element:item.variable_type,
          filters:item.filters,
          api_field_name:(item.variable_name)?item.variable_name:item.name,
          field_name:(item.variable_name)?item.variable_name:item.name,
          field_type:(item.fieldtype_name)?item.fieldtype_name:item.field_type_name,
          fieldTypeId:item.id,
          level:0,
          fieldName:(item.variable_name)?item.variable_name:item.name,
          display_name:(item.variable_name)?item.variable_name:item.name,
          isDepenedField:false,
          depenedFields:[],
          options:[],
          is_custom_field : true,
          is_master_window : false,
          window_id:item.id,
          lookup_window_name:(item.fields && item.fields.length>0)?(item.variable_name)?item.variable_name:item.name:'',
          system_window_name:(item.fields && item.fields.length>0)?(item.variable_name)?item.variable_name:item.name:null,
          fields_with_filters:{
              field_groups : null,
              window_fields : convertVariablesToWindowFields(item.fields,item,ratePath)
          },
          variable_field_id_path:ratePath
        }
    }
    return fields;
}

export const convertVariablesToWindowFields = (fields,itemP,ratePath='')=>{
    let variables = [];
    if(fields!==undefined)
    fields.forEach((item)=>{
        let rateVariablePath = (ratePath!=='')?ratePath+'.'+item.id:itemP.id+'.'+item.id;
            variables.push({
                id:item.id,
                element:item.variable_type,
                filters:item.filters,
                api_field_name:item.name,
                field_name:item.name,
                field_type:(item.fieldtype_name)?item.fieldtype_name:item.field_type_name,
                fieldTypeId:item.id,
                level:0,
                fieldName:item.name,
                isDepenedField:false,
                depenedFields:[],
                options:[],
                is_custom_field : true,
                is_master_window : false,
                lookup_window_name:(item.fields && item.fields.length>0)?item.name:'',
                system_window_name:(item.fields && item.fields.length>0)?item.name:null,
                // fifff:item,
                dependent_layout : recursiveFields(item,rateVariablePath),
                variable_field_id_path:rateVariablePath
            })
    });
    return variables;
}

export const isValidUUID=(val)=>{
  return uuidValidate(val);
}


export const updateImageSources=(body)=>{
  let updatedBody = body ;
  if(isSet(body,null)!==null){
    let imageIds = updatedBody.match(/[^#SIMG(\}]+(?=\))/g);
    // console.log('imageIds',imageIds);
    try{
      if(imageIds!==null){
        imageIds.forEach((image)=>{
            if(image!=null && isValidUUID(image)){  
              let ImageData = ShipConstants.API_URL+'files/download?fileId='+image; 
              if(ImageData!==null){
                updatedBody = updatedBody.replace('cid:#SIMG('+image+')', ImageData);
              }
            }
        })
    }
    }catch(error){
      console.log("Erron On Email body content regex",error);
    }
  }
  
  return updatedBody;
}

export const revertImageSources = (body)=>{
  let updatedBody = body;
  let imageIds = updatedBody.match(/fileId=(.*?)(?=")/g); //.match(/(?<=fileId=)(.*?)(?=")/g);
  try{
    if(imageIds!=null ){
      imageIds.forEach((image)=>{
          if(image!=null && isValidUUID(image)){
            updatedBody = updatedBody.replace(ShipConstants.API_URL+'files/download?fileId='+image+'"', "cid:#SIMG("+image+")\"");    
          }
      })
  }
  }catch(error){
    console.error("error",error);
  }
  return updatedBody;
}

export const addOrRemoveObject = (arrayOfObjects, condition, index, newObject)=> {
    if (condition) {
      // Add a new object at a specific index
      arrayOfObjects.splice(index, 0, newObject);
    } else {
      // Remove the object at a specific index
      arrayOfObjects.splice(index, 1);
    }
  }
  
  export const generateRandomClassName = () => {
    const userInfo  = getUserInfo();
    const fName = userInfo.data.first_name;
    const lName = userInfo.data.last_name;
    const userName = capitalizeFirstLetter(fName)+capitalizeFirstLetter(lName);
    const organizationName = capitalizeFirstLetter(userInfo.data.org_info.organization_name.split(" ").join("")) ;
    return removeSpecialCharacters(organizationName + userName);
  }
  
  export const toCamelCase = (inputString) => {
    const camelCaseString = inputString.replace(/\s+/g, '');
  
      // Make sure the first character is always in lowercase
      return camelCaseString.charAt(0).toLowerCase() + camelCaseString.slice(1);
    }

   const  removeSpecialCharacters =(inputString)=> {
      // Use a regular expression to remove non-alphanumeric characters
      const resultString = inputString.replace(/[^a-zA-Z0-9]/g, "");
      return resultString;
  }

  export const updatedDynamicUrlAsync =  (fieldGroups,expression)=>{
    return new Promise((resolve,reject)=>{
       const paramsPattern = /[^${\}]+(?=})/g;
        let extractParams = expression.match(paramsPattern);
        isSet(extractParams,[]).forEach((fieldExpression)=>{
            let expFieldNameSpit = fieldExpression.split(".");
            let expLength = expFieldNameSpit.length;
            let fieldName = (expLength>0)?expFieldNameSpit[expLength-1]:"";
            let lookupWindow = (expLength>1)?expFieldNameSpit[expLength-2]:"";
            let parentWindow = (expLength>2)?expFieldNameSpit[expLength-3]:"";
            isSet(fieldGroups,[]).forEach((group)=>{
              isSet(group.data,[]).forEach((data)=>{
                if(data.selectedValue!==undefined){
                  if(parentWindow===""){
                    if(fieldName===data.api_custom_field_name){
                      expression = expression.replace("${"+lookupWindow+"."+fieldName+"}",(data.selectedValue!==undefined &&  data.selectedValue!==null)?data.selectedValue:"");    
                    }
                  }else if(data.element==="Lookup" && IsJsonString(data.selectedValue) ){
                    try{
                      let lookupData = JSON.parse(data.selectedValue);
                      if(lookupData!==undefined && lookupData!==null){
                        if(isSet(lookupData.windowName,lookupData.window_name)!==undefined && isSet(lookupData.windowName,lookupData.window_name)===data.value){
                          lookupData.fieldGroups.forEach((group)=>{
                            isSet(group.data,[]).forEach((data)=>{
                              if(data.selectedValue!==undefined){
                                if(fieldName===data.api_custom_field_name){
                                  expression = expression.replace("${"+parentWindow+"."+lookupWindow+"."+fieldName+"}",(data.selectedValue!==undefined &&  data.selectedValue!==null)?data.selectedValue:"");    
                                }
                              }
                            })
                          });
                        }
                      }
                    }catch(error){
                      reject("JSONERRO"+error);
                    }
                  }
                }
                
              })
            })
        })  
        resolve(isSet(expression,""));
    });
     
  }

  export const BooleanOf = (val)=>{
    const truthyValues = [true, "true", 1, "1","TRUE"];
     return truthyValues.includes(val) ? true : false;
  }

  export const snakeToPascal = (str="") => {
      // Check if the string starts with "cf" and remove it
      if (str.startsWith('cf_')) {
        str = str.slice(3); // Remove "cf_" (3 characters)
    } else if (str.startsWith('cf')) {
        str = str.slice(2); // Remove "cf" (2 characters) if no underscore
    }
      return str
          .split('_') // Split the string by underscores
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
          .join(' '); // Join the words together
  };




  
export const decryptAES =  (response) => {
  // if(IsEncrypted===false){
  //   return response;
  // }
  const encryptionKey =  'Tkq|corb33hhtt45';//process.env.REACT_APP_ENCRYPTION_KEY;
  const ivParameter =  'Wqbut$te73ty7y54';//process.env.REACT_APP_IV_PARAMETER_KEY;
  // console.log('encryptionKey',encryptionKey,ivParameter);
    try {
      // Convert decrypted data to string
      const encryptedStr = response;
      const decodedData = CryptoJS.enc.Base64.parse(encryptedStr);
      const decryptedData = CryptoJS.AES.decrypt(
        { ciphertext: decodedData },
        CryptoJS.enc.Utf8.parse(encryptionKey),
        { iv: CryptoJS.enc.Utf8.parse(ivParameter) }
      );
      const serializedData = CryptoJS.enc.Utf8.stringify(decryptedData);
      // let serializedData = decrypted;
      // try{
      //   serializedData = decrypted.match(/"(.*)"/)[1];
      // }catch(e){

      // }
    //  console.log('serializedData',serializedData);
     const binaryString  = atob(serializedData);
      
      const binaryArray = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        binaryArray[i] = binaryString.charCodeAt(i);
      }
      const decompressedData = pako.inflate(binaryArray, { to: 'string' });
      const returnData =  JSON.parse(decompressedData);
      return returnData;
    } catch (error) {
        console.error('Error decrypting data:', error);
        return null;
    }
};

// Helper function to convert a file to base64
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result.split(',')[1]);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
};


const arrayBufferToBase64 = (buffer) => {
  const binary = [];
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary.push(String.fromCharCode(bytes[i]));
  }
  return binary.join('');
}
 // if (data instanceof FormData) {
    //   const formDataObject = {};
    //   const entries = Array.from(data.entries());
    //   await Promise.all(entries.map(async ([key, value]) => {
    //     if (value instanceof File) {
    //       const base64File = await fileToBase64(value);
    //       formDataObject[key] = {
    //         name: value.name,
    //         type: value.type,
    //         size:value.size,
    //         fileData: base64File
    //       };
    //     } else {
    //       formDataObject[key] = value;
    //     }
    //   }));
    
    //   data = formDataObject;
    // }
    // let files = [];
export const encryptAES = (data)=>{
  // return data;
  const encryptionKey = process.env.REACT_APP_API_KEY;
  try {
   
    let formDataObject = {};
    const formData = new FormData();
    if (data instanceof FormData) {
      const entries = Array.from(data.entries());
      
      entries.forEach(([key, value]) => {
        if (value instanceof File) {
          formData.append(key, value);
        } else {
          formDataObject[key] = value;
        }
      });

      data = formDataObject;
    }

    const text = JSON.stringify(data);
    // console.log('formDataObject',text);
    const compressedData = pako.deflate(text, { to: 'string' });
    const compressedDatas = arrayBufferToBase64(compressedData);

    
    // const compressedDatas = String.fromCharCode.apply(null, compressedData)
    const serializedData  = btoa(compressedDatas);
    // console.log('serializedData',serializedData);
    const serializedString = `s:${serializedData.length}:"${serializedData}";`;
    // Encrypt the text
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(serializedString, CryptoJS.enc.Base64.parse(encryptionKey), {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    const encryptedStr = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

  
    // Encode IV and encrypted value to Base64
    const ivBase64 = CryptoJS.enc.Base64.stringify(iv);
    const valueBase64 = encrypted.toString();
       // Step 4: Generate MAC (Message Authentication Code)
    const mac = CryptoJS.HmacSHA256(ivBase64 + encryptedStr, CryptoJS.enc.Base64.parse(encryptionKey)).toString(CryptoJS.enc.Hex);

    // Create the object structure similar to the one you provided for decryption
    const encryptedData = {
      iv: ivBase64,
      value: valueBase64,
      mac: mac, // Add MAC if needed
      tag: '' // Add tag if needed for AEAD algorithms
    };

    // Serialize and encode the data as a JSON string
    const jsonData = JSON.stringify(encryptedData);
    const base64EncodedData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(jsonData));
    // console.log('base64EncodedData',base64EncodedData);
    // return {
    //   encrypted_data:base64EncodedData
    // };
    
    formData.append('encrypted_data', base64EncodedData);
    // console.log('formData',formData);
    // files.forEach(({ key, value }) => {
    //   formData.append(key, value);
    // });

    return formData;
  } catch (error) {
    console.error('Error encrypting data:', error);
    return null;
  }
}


export const  validURL =(str)=> {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}


export const getHardCodedIds = (key)=>{
  //1a96c203-617a-4364-9809-c2180350a554 - jk
  //44fc5bb1-5eda-4b7f-8a3e-bb51e0c68199 - demo org
  const values = {
    //jk
    '1a96c203-617a-4364-9809-c2180350a554':{
      'readyForShipping':'229b5a55-81d7-4b73-94c4-f5bd0d099be5',
      'envelopeId':'85db4da6-c2d9-4811-a18e-bb5228ff5534',
      'trackingWindowId':'02c23beb-b453-4b02-8d69-e23f06c2c522',
      'totalQuotedCharge':'cf_total_quoted_charge',
      'isSummaryLabel':"true"
    },
    '44fc5bb1-5eda-4b7f-8a3e-bb51e0c68199':{
      // demo org
      'readyForShipping':'f6e454e1-1d09-4a1d-b532-6f686f783621',
      'envelopeId':'9d6aee28-955c-4d53-9d37-7062dfa01c7c',
      'trackingWindowId':'02c23beb-b453-4b02-8d69-e23f06c2c534',
      'totalQuotedCharge':'total_charge',
       'isSummaryLabel':"false"
    }
  }
  try{
    return values[getOrgId()][key];
  }catch(e){
    return "";
  }
  
}


export const truncateString = (str, maxLength)=> {
  // console.log('str',str);
  const strToString = isSet(str,'');
  if (strToString.length <= maxLength) return strToString;
  return strToString.slice(0, maxLength - 3) + '...';
}